import store from '@/store';

/**
 * Router Guard: If user is authenticated
 */
export const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next();

    return;
  }
  next('/login');
};

/**
 * Router Guard: If user is not authenticated
 */
export const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next();

    return;
  }
  next('/');
};

export default {
  ifAuthenticated,
  ifNotAuthenticated,
};



// WEBPACK FOOTER //
// ./src/apps/auth/router/guards.js